module.exports = __webpack_public_path__ + "img/purple-1.0af8ef11.png";